export type TablePropertiesScroll = {
  top: number;
  left: number
}

export type PinnedRows = Array<string>;
export type SelectedRows = Array<string>;

export type TableProperties = {
  orderColumn?: number;
  pinnedRows?: PinnedRows;
  selectedRows?: SelectedRows;
  scroll?: TablePropertiesScroll;
}

export type TablePropertiesState = {
  [key: string]: TableProperties
}

export enum TablePropertiesAction {
  REPLACE_TABLE_PROPERTIES = 'REPLACE_TABLE_PROPERTIES',
  CHANGE_TABLE_PROPERTIES = 'CHANGE_TABLE_PROPERTIES',
  CHANGE_TABLE_PROPERTIES_PINNED_ROWS = 'CHANGE_TABLE_PROPERTIES_PINNED_ROWS',
}

export const SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE = 'saveTablePropertiesOnLocalStorage';

interface ReplaceTablePropertiesActionType extends TableProperties {
  type: TablePropertiesAction.REPLACE_TABLE_PROPERTIES;
  scope: string;
  SAVE_LOCAL_STORAGE?: typeof SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE;
}

interface ChangeTablePropertiesActionType extends TableProperties {
  type: TablePropertiesAction.CHANGE_TABLE_PROPERTIES;
  scope: string;
  SAVE_LOCAL_STORAGE?: typeof SAVE_TABLE_PROPERTIES_ON_LOCAL_STORAGE;
}

export type TablePropertiesActionTypes = ReplaceTablePropertiesActionType | ChangeTablePropertiesActionType;

export type ChangeTablePropertiesOrderColumn = (orderColumn: number, isPersistent?: boolean, forceScope?: string) => void;
export type ChangeTablePropertiesPinnedRows = (pinnedRows: PinnedRows, isPersistent?: boolean, forceScope?: string) => void;
export type ChangeTablePropertiesSelectedRows = (pinnedRows: SelectedRows, isPersistent?: boolean, forceScope?: string) => void;
export type ChangeTablePropertiesScroll = (scroll: TablePropertiesScroll, isPersistent?: boolean, forceScope?: string) => void;
